<a class="link" href="#">
  <svg-icon src="/assets/img/icons/logo.svg" />
</a>
